export enum SECTIONS {
  opening = 'opening',
  introduction = 'introduction',
  organicInsights = 'organicInsights',
  shares = 'shares',
  advocates = 'advocates',
  executives = 'executives',
  takeawaysAndNextSteps = 'takeawaysAndNextSteps',
}
